import React, { useEffect, useRef } from "react";
import { Col, Card } from "react-bootstrap";
import { useDonor } from "../../../../../context/donor/donor.context";
import { useTranslation } from "react-i18next";
import BloodGroupGenderBarChart from "./BloodGroupGenderBarChart";

const DonorsBloodGroupGenderChart = () => {
  const { 
    bloodGroupGenderStatistics, 
    fetchDonorGenderBloodGroupStatistics, 
    loading 
  } = useDonor();
  const { t } = useTranslation();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      console.log("Fetching blood group gender statistics...");
      fetchDonorGenderBloodGroupStatistics();
      hasFetchedRef.current = true;
    }
  }, []);

  useEffect(() => {
    console.log("Current bloodGroupGenderStatistics:", bloodGroupGenderStatistics);
    console.log("Current loading:", loading);
  }, [bloodGroupGenderStatistics, loading]);

  const handleRefresh = () => {
    fetchDonorGenderBloodGroupStatistics();
  };

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <Card.Title>{t("genderDistributionByBloodGroup")}</Card.Title>
          <button
            className="btn btn-sm btn-primary"
            onClick={handleRefresh}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                {t("Loading")}...
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="me-1"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                </svg>
              </>
            )}
          </button>
        </Card.Header>

        <Card.Body>
          {loading && !bloodGroupGenderStatistics ? (
            <div className="text-center py-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">{t("Loading")}...</span>
              </div>
            </div>
          ) : bloodGroupGenderStatistics && bloodGroupGenderStatistics.totalDonors > 0 ? (
            <>
              <BloodGroupGenderBarChart bloodGroupGenderStatistics={bloodGroupGenderStatistics} />
              <div className="mt-3 text-center">
                <div className="row">
                  <div className="col-md-4">
                    <strong>{t("donors.totalDonors")}: </strong>{bloodGroupGenderStatistics.totalDonors}
                  </div>
                  <div className="col-md-4">
                    <span style={{ color: "#3b4cb8" }}>● </span>
                    <strong>{t("donors.totalMale")}:</strong>{" "}
                    {bloodGroupGenderStatistics.summary?.find(s => s.gender === "MALE")?.count || 0}
                  </div>
                  <div className="col-md-4">
                    <span style={{ color: "rgba(255, 99, 132, 0.7)" }}>● </span>
                    <strong>{t("donors.totalFemale")}:</strong>{" "}
                    {bloodGroupGenderStatistics.summary?.find(s => s.gender === "FEMALE")?.count || 0}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-5">
              <p>{t("No data available")}</p>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorsBloodGroupGenderChart;
